import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  deleteResponseProjectBlock,
  getResponseProjectBlocks,
} from '../../../../../shared/api/magellan/responseProjectBlock';

export function useDeleteResponseProjectBlockMutation(projectId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ blockId }: { blockId: number }) =>
      deleteResponseProjectBlock(projectId, blockId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [getResponseProjectBlocks.name, projectId],
      });
    },
  });
}
